import { rootPath } from '@js/utils/url';
import templates from './vendor/templates';
import settings from './vendor/settings';
import { initWishlistPage } from './render';

(() => {
  // eslint-disable-next-line no-underscore-dangle
  const wishlistData = window.__wishListData;

  // eslint-disable-next-line no-underscore-dangle
  window.__initWishlistPage = (target) => initWishlistPage(target);

  if (!wishlistData) {
    console.error('Wishlist: initial data from `wishlist.liquid` was not set.');
    return;
  }

  WishlistKing.toolkit.init({
    ...wishlistData,
    templates,
    settings,
    events: {
      ready() {
        // App is ready and WishlistKing.toolkit can be used
      },
      addedToCart() {
        // This is a good place to trigger AJAX cart update
        window.scrollTo(0, 0);
        window.location.reload();
      },
      loginRequired(intent) {
        window.location = [
          `${rootPath()}account/login?wk-redirect=`,
          encodeURIComponent(
            JSON.stringify({
              path: window.location.pathname,
              intent,
            }),
          ),
        ].join('');
      },
    },
  });

  // Wishlist button on product page
  WishlistKing.observe(
    {
      selector: '.product-media',
      template: 'product',
    },
    (target) => {
      target.append(
        WishlistKing.createComponent('wishlist-button', {
          id: document.querySelector('.product-submit').getAttribute('data-product-id'),
        }),
      );
    },
  );

  // Wishlist button on collection page
  WishlistKing.observe(
    {
      selector: '.product__item[data-product-id]',
    },
    (target) => {
      target.append(
        WishlistKing.createComponent('wishlist-button-floating', {
          id: target.container.getAttribute('data-product-id'),
        }),
      );
    },
  );

  // Wishlist page
  WishlistKing.observe(
    {
      selector: '.main-content',
      template: 'page',
      handle: WishlistKing.toolkit.settings.wishlistPageHandle,
    },
    (target) => {
      initWishlistPage(target);
    },
  );

  // Shared wishlist page
  WishlistKing.observe(
    {
      selector: '.main-content',
      template: 'page',
      handle: WishlistKing.toolkit.settings.sharedWishlistPageHandle,
    },
    (target) => {
      target.insertAfter(WishlistKing.createComponent('wishlist-page-shared'));
    },
  );
})();
